export const defaults = {
  spread: { start: "0%", end: "50%" },
  x: "50%",
  y: "50%",
};

export const defaultDuration = "3s";

export const base = [
  {
    colors: ["hsla(28,100%,74%,1)"],
    x: ["40%"],
    y: ["20%"],
    spread: [defaults.spread],
    blend: ["normal"],
  },
  {
    colors: ["hsla(189,100%,56%,1)"],
    x: ["80%"],
    y: ["0%"],
    spread: [defaults.spread],
    blend: ["normal"],
  },

  {
    colors: ["hsla(355,100%,93%,1)"],
    x: ["0%"],
    y: ["50%"],
    spread: [defaults.spread],
    blend: ["normal"],
  },

  {
    colors: ["hsla(340,100%,76%,1)"],
    x: ["80%"],
    y: ["50%"],
    spread: [defaults.spread],
    blend: ["normal"],
  },

  {
    colors: ["hsla(22,100%,77%,1)"],
    x: ["0%"],
    y: ["100%"],
    spread: [defaults.spread],
    blend: ["normal"],
  },

  {
    colors: ["hsla(242,100%,70%,1)"],
    x: ["80%"],
    y: ["100%"],
    spread: [defaults.spread],
    blend: ["normal"],
  },

  {
    colors: ["hsla(343,100%,76%,1)"],
    x: ["0%"],
    y: ["0%"],
    spread: [defaults.spread],
    blend: ["normal"],
  },
];

export const names = [
  "Xtal",
  "Tha",
  "Pulsewidth",
  "Ageispolis",
  "i",
  "Green Calx",
  "Heliosphan",
  "We Are the Music Makers",
  "Schottkey 7th Path",
  "Ptolemy",
  "Hedphelym",
  "Delphium",
  "Actium",
  "Cornish Acid",
  "4",
  "To Cure A Weakling Child",
  "Fingerbib",
  "Goon Gumpas",
  "Peek 82454201",
  "Logan Rock Witch",
  "Yellow Calx",
  "Carn Marth",
  "Kesson Dalef",
  "Taking Control",
  "Mt Saint Michel",
  "Saint Michaels Mount",
  "Meltphace 6",
  "Omgyjya Switch7",
  "Hy a Scullyas Lyf a Dhagrow",
  "Petiatil Cx Htdui",
  "Beskhu3epnm",
  "Prep Gwarlek 3b",
  "Vordhosbn",
  "Ruglen Holon",
  "Bit 4",
  "Father",
  "Cock/Ver10",
  "54 Cymru Beats",
  "Lornaderek",
  "Jynweythek",
  "Gwarek2",
  "QKThr",
  "Ziggomatic V17",
  "Kladfvgbung Micshk",
  "Aussois",
  "Avril 14th",
  "Btoum-Roumada",
  "Gwely Mernans",
  "Nanou 2",
  "Orban Eq Trx4",
  "AFX 237 V7",
  "Bbydhyonchord",
  "Strotha Tynhe",
  "Come On You Slags!",
  "The Waxen Pith",
  "Alberto Balsalm",
  "Start as You Mean to Go On",
  "Ventolin",
  "Acrid Avid Jam Shred",
  "Wet Tip Hen Ax",
  "Mookid",
  "Cow Cud Is a Twin",
  "Next Heap With",
  "Icct Hedral",
  "Wax the Nip",
  "fz pseudotimestretch+e+3",
  "4 bit 9d api+e+6",
  "CIRCLONT14",
  "XMAS_EVET10",
  "PAPAT4",
  "CIRCLONT6A",
  "180db_",
  "produk 29",
  "syro u473t8+e",
  "s950tx16wasr10",
  "aisatsana",
  "Minipops 67",
  "Girl/Boy Song",
];

export const blendModes = [
  "normal",
  "multiply",
  "screen",
  "overlay",
  "darken",
  "lighten",
  "color-dodge",
  "color-burn",
  "hard-light",
  "soft-light",
  "difference",
  "exclusion",
  "hue",
  "saturation",
  "color",
  "luminosity",
];

export const ssAuthorsKey = "heroMeshAuthors";
